export enum IdentityProvider {
  OKTA = 'okta',
  ZIPARI = 'zipari',
}
